

const selectStyles = {
    control: (styles) => ({ ...styles, borderColor: "black", borderRadius: "10px", border: "1px solid #9e9e9e", height: "41px" }),
    menuPortal: (styles) => ({ ...styles, zIndex: 9999 }),
};
export default selectStyles